<h1 matDialogTitle>{{data.title}}</h1>

<mat-dialog-content>

  <ng-container *ngIf="integrationBusy; else integrationDone">
    <div style="text-align: center;margin: 16px;">
      Busy integrating with external systems, please wait ...
    </div>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </ng-container>
  <ng-template #integrationDone>
    <ng-container *ngIf="processDetails">
      <ng-container *ngFor="let detail of processDetails">
        <div class="main-container" [style.background-color]="detail.messageStatusColor">
          <div>
            <div class="message-desc">
              {{detail.messageDesc}}
            </div>
            <div class="message-status">
              <div>
                {{detail.messageCode}}
              </div>
              <div>
                {{detail.messageStatusDesc}} ({{detail.messageStatus}})
              </div>
            </div>
          </div>

          <div class="error-container">
            <ng-container *ngFor="let result of detail.sysproResults; let i=index">
              <div class="error-line" [ngStyle]="{'border-bottom-style': i < detail.sysproResults.length - 1 ? 'solid' : 'none'}">
                <div>
                  {{result.type}}
                </div>
                <div>
                  {{result.value}}
                </div>
              </div>
            </ng-container>
            <ng-container *ngFor="let result of detail.resultErrors; let i=index">
              <div class="error-line" [ngStyle]="{'border-bottom-style': i < detail.resultErrors.length - 1 ? 'solid' : 'none'}">
                <div>
                  {{result.desc}}
                </div>
              </div>
            </ng-container>
          </div>
        </div>

      </ng-container>
    </ng-container>

  </ng-template>

</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button [disabled]="integrationBusy" matDialogClose>Close</button>
</mat-dialog-actions>
